import template from './contract-mapping.html';
import controller from './contract-mapping.controller';

let contractMappingComponent = {
  restrict: 'E',
  template,
  controller
};

export default contractMappingComponent;



// WEBPACK FOOTER //
// ./client/pages/admin/integrations/quickbooks/capabilities/contract-mapping/contract-mapping.component.js